import React from 'react';
import cn from 'classnames';

import { Icon } from 'components/shared/Icon';
import { Typography } from 'components/shared/Typography';

import styles from './SelectTabs.module.scss';

export type SelectTabsItem = {
  value: string;
  label: string;
  icon?: string;
  count?: number | null;
};

/** DS "Select tabs" (Figma 1266:2901): pill filters with a single selected value. */
const SelectTabs = ({
  className,
  value,
  items,
  onChange,
}: {
  className?: string;
  value: string;
  items: SelectTabsItem[];
  onChange: (selectedValue: string) => void;
}) => (
  <div className={cn(styles.tabs, className)} role="group">
    {items.map((item) => {
      const isSelected = item.value === value;

      return (
        <button
          key={item.value}
          type="button"
          className={cn(styles.tab, { [styles.tabSelected]: isSelected })}
          aria-pressed={isSelected}
          onClick={() => onChange(item.value)}
        >
          {item.icon ? <Icon className={styles.icon} name={item.icon} /> : null}
          <Typography
            className={styles.label}
            component="span"
            variant="body2"
            weight="medium"
            mode="compact"
          >
            {item.label}
          </Typography>
          {item.count != null ? (
            <Typography
              className={styles.count}
              component="span"
              variant="body2"
              weight="medium"
              mode="compact"
            >
              {item.count}
            </Typography>
          ) : null}
        </button>
      );
    })}
  </div>
);

export default React.memo(SelectTabs) as any;
